import { useSyncExternalStore } from 'react';

export type Orientation = 'portrait' | 'landscape';

/**
 * The one breakpoint between the portrait and landscape layouts: wider than tall. CSS uses the
 * same condition, `@media (min-aspect-ratio: 1/1)`, in tokens.css and screen styles.
 */
export const LANDSCAPE_QUERY = '(min-aspect-ratio: 1/1)';

export function orientationOf(width: number, height: number): Orientation {
  return width >= height ? 'landscape' : 'portrait';
}

function subscribe(onChange: () => void) {
  const media = window.matchMedia(LANDSCAPE_QUERY);
  media.addEventListener('change', onChange);
  return () => {
    media.removeEventListener('change', onChange);
  };
}

/** The current layout orientation, matching the CSS breakpoint. */
export function useOrientation(): Orientation {
  return useSyncExternalStore(
    subscribe,
    () => (window.matchMedia(LANDSCAPE_QUERY).matches ? 'landscape' : 'portrait'),
    () => 'portrait',
  );
}
